import { Box } from '@mui/material';
import { BORDER_COLOR } from 'utils/theme';
import ClaimEvidenceBody from './ClaimEvidenceBody';
import ClaimEvidenceFooter from './ClaimEvidenceFooter';
import ClaimEvidenceHeader from './ClaimEvidenceHeader';

interface ClaimEvidenceProps {
  evidence: Source;
  sourceIndex: number;
  claimIndex: number;
  claim: Claim;
  isLastEvidenceIndex: number;
}

const ClaimEvidence = ({
  evidence,
  claim,
  sourceIndex,
  claimIndex,
  isLastEvidenceIndex,
}: ClaimEvidenceProps) => {
  return (
    <Box
      sx={{
        padding: {
          mobile: '20px 16px 16px',
          tablet: '25px 30px',
          desktop: '24px 50px',
        },
        background: 'white',
        borderLeft: `1px solid ${BORDER_COLOR}`,
        borderRight: `1px solid ${BORDER_COLOR}`,
        borderBottom: `1px solid ${BORDER_COLOR}`,
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        borderBottomLeftRadius: isLastEvidenceIndex === sourceIndex ? '12px' : '0px',
        borderBottomRightRadius: isLastEvidenceIndex === sourceIndex ? '12px' : '0px',
      }}
    >
      <ClaimEvidenceHeader sourceIndex={sourceIndex} evidence={evidence} claimIndex={claimIndex} />
      <ClaimEvidenceBody evidence={evidence} claim={claim} />
      <ClaimEvidenceFooter evidence={evidence} />
    </Box>
  );
};

export default ClaimEvidence;
